import { render, staticRenderFns } from "./LiveAccountContactClientAndClientUserView.vue?vue&type=template&id=07152b6b&scoped=true"
import script from "./LiveAccountContactClientAndClientUserView.vue?vue&type=script&lang=js"
export * from "./LiveAccountContactClientAndClientUserView.vue?vue&type=script&lang=js"
import style0 from "./LiveAccountContactClientAndClientUserView.vue?vue&type=style&index=0&id=07152b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07152b6b",
  null
  
)

export default component.exports